export type AirportBusEstimationTimeStrategy = "current-local-time";

export type AirportBusPassengerTypeOption = {
  code: string;
  /** i18n key under transport.* */
  labelKey: string;
};

export type AirportBusProviderI18nKeys = {
  /** e.g. transport.viennaAirportBusValidity — receives `{ hours }` */
  validity: string;
  /** e.g. transport.viennaAirportBusNonRefundable */
  nonRefundable: string;
};

/**
 * Provider-specific knobs for the shared Airport Bus flow.
 * Generic UI/module code must not hardcode vienna/lufthansa identifiers —
 * they come from this config (and from the API for branding).
 */
export type AirportBusProviderConfig = {
  /** URL + API transport-type segment, e.g. "vienna-airport-bus" */
  slug: string;
  /** Breadcrumb / fallback label when provider info has not loaded yet */
  fallbackDisplayName: string;
  passengerTypes: readonly AirportBusPassengerTypeOption[];
  /** Must match one of `passengerTypes.code` */
  defaultPassengerTypeCode: string;
  estimationTimeStrategy: AirportBusEstimationTimeStrategy;
  i18n: AirportBusProviderI18nKeys;
};

/** Relative confirmation path used by PaymentModal / booking redirects. */
export function getAirportBusConfirmationPath(slug: string): string {
  return `transport/${slug}/confirmation`;
}

/** Language-prefixed absolute path used by navigate() after paid booking. */
export function getAirportBusConfirmationNavigatePath(language: string, slug: string): string {
  return `/${language}/${getAirportBusConfirmationPath(slug)}`;
}

export function getAirportBusPathSuffix(slug: string): string {
  return `/transport/${slug}`;
}
